import PIXI from 'pixi.js/src';
import renderHelper from './../helpers/render';
import aguid from 'aguid';
import data from './../data/data';
import frameAnimationHelper from './../helpers/frame-animation';
import GameStore from './../stores/GameStore';
import './../../vendor/greensock-js/src/uncompressed/TweenLite.js';

const basket = {
  basketWidth: 42,
  basketHeight: 36,
  paused: false,
  basketAnimationImagePaths: [],


  /**
   * Sets up, adds event listeners
   * @returns {undefined} undefined
   */
  init() {
    this.gameStoreListener = this.onGameStoreChange.bind(this);
    GameStore.addChangeListener(this.gameStoreListener);
  },


  /**
   * Creates a basket
   * @param {Number} level - The current level of the game
   * @returns {undefined} undefined
   */
  create(level, isSpecial) {
    const _this = this;
    const randLeftRight = Math.round(Math.random() * 1);
    const randX = randLeftRight ? -this.basketWidth : window.innerWidth;
    const randY = 10 + Math.floor(Math.random() * (window.innerHeight / 6));
    let levelMult = level;
    if (levelMult > 2.5) {
      levelMult = 2.5;
    }
    const randSpeed = 4.8 - (levelMult * 0.5) - (Math.random() * (levelMult * 0.5));
    const specialBasketPosition = (window.innerWidth / 5);
    let xTargetPos = randLeftRight ? window.innerWidth : -this.basketWidth;

    this.basketAnimationImagePaths = data.basketPaths;

    this.basketContainer = new PIXI.Container();
    renderHelper.stage.addChild(this.basketContainer);
    this.basketContainer.x = randX;
    this.basketContainer.y = randY;
    this.basketContainer.width = this.basketWidth;
    this.basketContainer.height = this.basketHeight;

    this.basketSprite = new PIXI.Sprite(
      PIXI.loader.resources['assets/images/basket/basket-1.gif'].texture
    );
    this.basketSprite.width = this.basketWidth;
    this.basketSprite.height = this.basketHeight;

    this.basketContainer._gameId = aguid();
    this.basketContainer.addChild(this.basketSprite);

    if (isSpecial) {
      xTargetPos = randLeftRight ? specialBasketPosition :
        (window.innerWidth - specialBasketPosition - this.basketWidth);
      const originalXtargetPos = this.basketContainer.x;
      this.basketContainer._isSpecial = true;

      this.basketSprite.texture =
        PIXI.loader.resources[data.specialBasketPath].texture;

      this.tween = window.TweenLite.to(
        this.basketContainer,
        0.2,
        {
          x: xTargetPos,
          ease: window.Linear.easeNone,
          onComplete() {
            _this.tween = window.TweenLite.to(
              _this.basketContainer,
              0.2,
              {
                x: originalXtargetPos,
                delay: 1.5,
                ease: window.Linear.easeNone,
                onComplete() {
                  _this.destroy();
                },
              }
            );
          },
        }
      );
    } else {
      this.tween = window.TweenLite.to(
        this.basketContainer,
        randSpeed,
        {
          autoKill: true,
          x: xTargetPos,
          ease: window.Linear.easeNone,
          onComplete() {
            _this.destroy();
          },
        }
      );
    }

    GameStore.addBasket(this.basketContainer);
  },


  /**
   * Called when a CHANGE event is emitted from the GameStore
   * @returns {undefined} undefined
   */
  onGameStoreChange() {
    const _this = this;
    const state = GameStore.getState();

    if (state.basketToRemove &&
      state.basketToRemove._gameId === this.basketContainer._gameId) {
      this.willBeRemoved = true;
      this.tween.kill();

      this.basketContainer.removeChild(this.basketSprite);

      frameAnimationHelper.create(
        this.basketContainer,
        this.basketAnimationImagePaths,
        0.1,
        false,
        this.basketWidth,
        this.basketHeight);

      setTimeout(() => {
        _this.destroy();
      }, 100);
    }

    if (state.paused) {
      if (!this.paused) {
        this.paused = true;
        this.tween.pause();
      }
    } else {
      if (this.paused) {
        this.paused = false;
        this.tween.resume();
      }
    }
  },


  /**
   * Destroys the basket
   * @returns {undefined} undefined
   */
  destroy() {
    if (this.tween) {
      this.tween.kill();
      this.tween = null;
    }

    GameStore.removeBasket(this.basketContainer);
    GameStore.removeChangeListener(this.gameStoreListener);
    renderHelper.stage.removeChild(this.basketContainer);
  },
};

export default basket;



/** WEBPACK FOOTER **
 ** ./assets/js/src/graphics/basket.js
 **/